export default {
    en: {
        model_preview: "Model Preview",
        format: "Format",
        size: "Size",
        file: "File",
        beta_count_label: "{0} Credits Remaining",
        remain_count_label: "{0} Credits Remaining",
        file_upload: "File Upload",
        wireframe: "Wireframe",
        file_upload_info1: "Drag & drop your file here or click to browse",
        file_upload_info2: "(up to {0}MB)",
        ai_optimize_title1: "AI Recommended",
        ai_optimize_title2: "AUTO",
        ai_recommend_ratio_title1: "Recommended",
        ai_recommend_ratio_title2: "Reduction Rate",
        ai_recommend_level_title: "Optimization Level",

        continue_auto_mesh_issue: "Auto Error Detection - Pro Version Coming Soon",
        auto_mesh_issue: "Auto Error Detection",

        mesh_optimize_setting_title: "Mesh Optimization Settings",
        mesh_optimize_level: "Optimization Level",
        reduce_ratio: "(Reduction Rate)",
        start_optimize: "Start Optimization",
        completed_download: "Download Completed!",
        complete_optimize: "Optimization Complete! Download",
        processing_optimize: "Optimizing...",
        optimize_effect: "Optimization Results",
        polygon: "Polygons",
        vertex: "Vertices",
        file_size: "File Size",
        rendering_performance: "Rendering Performance",
        optimization_summary: " Summary",
        summary_text: "Vertex count changed from {0} to {1}, polygon count from {2} to {3}, and file size from {4}MB to {5}MB, improving rendering performance by {6}%.",
        // "Reduced {0} vertices to {1} and decreased file size from {2}MB to {3}MB. This represents a {4}% vertices reduction and {5}% file size reduction.",


        warning: "Higher values reduce more vertices but may decrease quality.",
        output_warning: "(Converting to a different format may increase the file size.)",


        reduction: "Reduced",
        improvement: "improved",


        optimize_help_title: "What is Optimization Level",
        optimize_help_desc: "Optimization level is a setting that determines how much data to remove from your original 3D model.",
        optimize_help_example_label: "· Examples",
        optimize_help_example1: "60% optimization → Removes 60% of original data, retains 40%",
        optimize_help_example2: "80% optimization → Removes 80% of original data, retains 20%",
        optimize_help_quality_warning_symbol: "Note:",
        optimize_help_quality_warning1: "Higher levels create lighter files but reduce detail quality.",
        optimize_help_quality_warning2: "Choose the level that best balances file size and quality.",

        optimize_help_reduce_warning1: "Reduction rate may be lower than expected due to edge",
        optimize_help_reduce_warning2: "preservation and UV map (texture) preservation settings.",

        original: "Original",
        optimized: "Optimized",

        output_format: "Output Format",

        before_optimize: "Click Start Optimization to begin.",

        additionUploadBtn: "MTL/Texture Upload",
        additionUploadTitle: "MTL/Texture Upload",
        additionFileSelected: "Select File",
        additionFolderSelected: "Select Folder",

        additionUploadedLabel: "Uploaded Files: {0}",
        noAdditionFiles: "No Files uploaded",
        additionUpload: "Upload",
        additionPath: "Path",
        additionSize: "Size",
        addtionDeleteAll: "Delete All",


        betaHelpTitle: "Beta Test Benefits",
        betaHelpDesc1: "· 30-day free access upon joining beta",
        betaHelpDesc2: "· File uploads up to 100MB per file",
        betaHelpDesc3: "· 1GB storage capacity",
        betaHelpDesc4: "· 10 credits provided (10 optimizations available)",
        betaHelpDesc5: "· +10 bonus credits for completing survey",
        betaHelpDesc6: "· Download results within 3 days of feedback",
        betaHelpDesc7: "· Special perks for beta testers at official launch",

        aiHelpTitle: "What is AI Optimization Recommendation?",
        aiHelpDesc: "AI automatically analyzes the characteristics of your uploaded model and recommends the optimal ratio that provides the best balance between file size and quality.",
    },
    ko: {
        model_preview: "모델 미리보기",
        format: "Format",
        size: "Size",
        file: "File",
        beta_count_label: "베타테스트 남은 크레딧 {0}회",
        remain_count_label: "남은 크레딧 {0}회",
        file_upload: "파일 업로드",
        wireframe: "와이어 프레임",

        file_upload_info1: "Drag & drop your file here or click to browse",
        file_upload_info2: "(up to {0}MB)",
        ai_optimize_title1: "AI 최적화 추천",
        ai_optimize_title2: "AUTO",
        ai_recommend_ratio_title1: "추천 감소율",
        ai_recommend_ratio_title2: " ",
        ai_recommend_level_title: "최적화 레벨",

        continue_auto_mesh_issue: "자동 오류 감지 기능 - Pro버전 오픈 예정",
        auto_mesh_issue: "자동 오류 감지 기능",

        mesh_optimize_setting_title: "메시 최적화 설정",
        mesh_optimize_level: "최적화 레벨",
        reduce_ratio: "(감소율)",
        start_optimize: "최적화 시작",
        completed_download: "다운로드 완료!",
        complete_optimize: "최적화 완료! 다운로드",
        processing_optimize: "최적화 중",
        optimize_effect: "최적화 결과",
        polygon: "폴리곤",
        vertex: "버텍스",
        file_size: "파일 크기",
        rendering_performance: "렌더링 성능",
        optimization_summary: "요약",
        summary_text: "버텍스 수는 {0}개에서 {1}개로, 폴리곤 수는 {2}개에서 {3}개로, 파일 크기는 {4}MB에서 {5}MB로 변화하여, 렌더링 성능이 {6}% 향상되었습니다.",

        //"{0}개의 버텍스을 {1}개로 줄이고 파일 크기를 {2}MB에서 {3}MB로 감소시켰습니다. 이는 {4}% 버텍스 감소와 {5}% 파일 크기 감소를 나타냅니다.",


        warning: "값이 클수록 더 많은 버텍스가 감소되지만 품질이 저하될 수 있습니다.",
        output_warning: "(원본과 다른 포맷으로 변환하면 파일 크기가 증가할 수 있습니다.)",


        reduction: "감소",
        improvement: "향상",


        optimize_help_title: "최적화 레벨이란?",
        optimize_help_desc: "최적화 레벨은 원본 3D 모델에서 얼마나 많은 데이터를 제거할지 <br/>결정하는 설정입니다.",
        optimize_help_example_label: "· 예시",
        optimize_help_example1: "60% 최적화 = 원본데이터의 60%를 제거하여 40%만 남김",
        optimize_help_example2: "80% 최적화 = 원본데이터의 80%를 제거하여 20%만 남김",
        optimize_help_quality_warning_symbol: "※",
        optimize_help_quality_warning1: "레벨이 높을수록 파일은 가벼워지지만 디테일은 줄어듭니다.",
        optimize_help_quality_warning2: "파일 크기와 품질의 균형을 고려해 선택하세요.",

        optimize_help_reduce_warning1: "엣지 보존 및 UV 맵(텍스처) 보존 설정으로 인해 예상보다 감소율이",
        optimize_help_reduce_warning2: "낮을 수 있습니다.",

        original: "원본",
        optimized: "최적화",


        output_format: "출력 포맷",

        before_optimize: "최적화 시작 버튼을 눌러주세요.",


        additionUploadBtn: "MTL/Texture 업로드",
        additionUploadTitle: "MTL/Texture 업로드",
        additionFileSelected: "파일 선택",
        additionFolderSelected: "폴더 선택",

        additionUploadedLabel: "업로드된 파일 {0}개",
        noAdditionFiles: "업로드된 파일 없음",
        additionUpload: "업로드",
        additionPath: "경로",
        additionSize: "크기",
        addtionDeleteAll: "모두 삭제",


        betaHelpTitle: "베타테스트 혜택 안내",
        betaHelpDesc1: "· 베타테스트 가입 시 30일간 무료 이용",
        betaHelpDesc2: "· 파일 당 최대 100MB 업로드 가능",
        betaHelpDesc3: "· 스토리지 1GB 지원",
        betaHelpDesc4: "· 10 크레딧 제공 (최적화 10회 가능)",
        betaHelpDesc5: "· 설문 참여 시 +10 크레딧 추가",
        betaHelpDesc6: "· 피드백 후 3일간 다운로드 가능",
        betaHelpDesc7: "· 정식 버전 출시 시 베타테스트 전용 특별 혜택 제공",

        aiHelpTitle: "AI 최적화 추천이란?",
        aiHelpDesc: "업로드된 모델의 특성을 AI가 자동으로 분석하여, 파일 크기와 품질의 균형이 가장 좋은 최적화 비율을 추천해 드립니다.",
    },
    ja: {
        model_preview: "モデルプレビュー",
        format: "Format",
        size: "Size",
        file: "File",
        beta_count_label: "ベータテスト残りクレジット {0}",
        remain_count_label: "残りクレジット {0}",
        file_upload: "ファイルアップロード",
        wireframe: "ワイヤーフレーム",

        file_upload_info1: "Drag & drop your file here or click to browse",
        file_upload_info2: "(up to {0}MB)",
        ai_optimize_title1: "AI最適化推奨",
        ai_optimize_title2: "AUTO",
        ai_recommend_ratio_title1: "추천 감소율",
        ai_recommend_ratio_title2: " ",
        ai_recommend_level_title: "최적화 레벨",

        continue_auto_mesh_issue: "自動エラー検出機能- Pro版リリース予定",
        auto_mesh_issue: "자동 오류 감지 기능",

        mesh_optimize_setting_title: "メッシュ最適化設定",
        mesh_optimize_level: "最適化レベル",
        reduce_ratio: "(削減率)",
        start_optimize: "最適化を開始",
        completed_download: "ダウンロード完了!",
        complete_optimize: "最適化完了! ダウンロード",
        processing_optimize: "最適化中",
        optimize_effect: "最適化結果",
        polygon: "ポリゴン",
        vertex: "頂点",
        file_size: "ファイルサイズ",
        rendering_performance: "レンダリング性能",
        optimization_summary: "概要",
        summary_text: "頂点数は{0}個から{1}個へ、ポリゴン数は{2}個から{3}個へ、ファイルサイズは{4}MBから{5}MBへ変化し、レンダリングパフォーマンスが{6}%向上しました。",

        //"{0}개의 버텍스을 {1}개로 줄이고 파일 크기를 {2}MB에서 {3}MB로 감소시켰습니다. 이는 {4}% 버텍스 감소와 {5}% 파일 크기 감소를 나타냅니다.",


        warning: "値が大きいほどポリゴンは減りますが、品質も低下します。",
        output_warning: "(形式変換時、ファイルサイズが増加する場合があります。)",


        reduction: "감소",
        improvement: "향상",


        optimize_help_title: "最適化レベルとは?",
        optimize_help_desc: "最適化レベルは、元の3Dモデルからどれだけのデータを<br/>削除するかを決定する設定です。",
        optimize_help_example_label: "· 例",
        optimize_help_example1: "60%最適化= 元データの60%を削除し、40%のみ残す",
        optimize_help_example2: "80%最適化= 元データの80%を削除し、20%のみ残す",
        optimize_help_quality_warning_symbol: "※",
        optimize_help_quality_warning1: "レベルが高いほどファイルは軽くなりますが\nディテールは減少します。",
        optimize_help_quality_warning2: "ファイルサイズと品質のバランスを考慮して選択してください。",

        optimize_help_reduce_warning1: "エッジ保存およびUVマップ(テクスチャ)保存設定により、",
        optimize_help_reduce_warning2: "予想より削減率が低い場合があります。",

        original: "オリジナル",
        optimized: "最適化",


        output_format: "出力形式",

        before_optimize: "最適化開始ボタンを押してください",


        additionUploadBtn: "MTL/Texture アップロード",
        additionUploadTitle: "MTL/Texture アップロード",
        additionFileSelected: "ファイル選択",
        additionFolderSelected: "フォルダ選択",

        additionUploadedLabel: "アップロードされたファイル{0}個",
        noAdditionFiles: "No files uploaded",
        additionUpload: "アップロード",
        additionPath: "パス",
        additionSize: "サイズ",
        addtionDeleteAll: "すべて削除",


        betaHelpTitle: "ベータテスト特典のご案内",
        betaHelpDesc1: "· ベータテスト登録時30日間無料で利用可能",
        betaHelpDesc2: "· ファイル当たり最大100MBまでアップロード可能",
        betaHelpDesc3: "· ストレージ1GBサポート",
        betaHelpDesc4: "· 10クレジット提供(最適化10回可能)",
        betaHelpDesc5: "· アンケート参加時+10クレジット追加",
        betaHelpDesc6: "· フィードバック後3日間ダウンロード可能",
        betaHelpDesc7: "· 正式版リリース時、ベータテスト限定特別特典を提",


        aiHelpTitle: "AI最適化推奨とは?",
        aiHelpDesc: "アップロードされたモデルの特性をAIが自動で分析し、ファイルサイズと品質のバランスが最も良い最適化比率を推奨いたします。",
    },
};
